"use client";

import { useEffect, useState } from "react";
import { sendContactMessage } from "./contactActions";

/** Zeitstempel vor Ablauf erneuern, damit lange geöffnete Formulare gültig bleiben. */
const TOKEN_REFRESH_MS = 30 * 60 * 1000;

export default function ContactForm() {
    const [renderedAt, setRenderedAt] = useState("");

    useEffect(() => {
        let active = true;

        const loadToken = async () => {
            try {
                const response = await fetch("/api/form-token", { cache: "no-store" });
                const data = (await response.json()) as { token?: string };
                if (active && data.token) {
                    setRenderedAt(data.token);
                }
            } catch (error) {
                console.error("Error fetching form token:", error);
            }
        };

        loadToken();
        const interval = setInterval(loadToken, TOKEN_REFRESH_MS);

        return () => {
            active = false;
            clearInterval(interval);
        };
    }, []);

    return (
        <form className="space-y-6" action={sendContactMessage}>
            {/* Honeypot: für Menschen unsichtbar, Bots füllen ihn aus. Serverseitig wird abgelehnt. */}
            <div
                aria-hidden="true"
                style={{
                    position: "absolute",
                    width: "1px",
                    height: "1px",
                    overflow: "hidden",
                    clipPath: "inset(50%)",
                    whiteSpace: "nowrap",
                    opacity: 0,
                    pointerEvents: "none",
                }}
            >
                <label htmlFor="website">Website (bitte leer lassen)</label>
                <input type="text" id="website" name="website" tabIndex={-1} autoComplete="off" defaultValue="" />
            </div>
            <input type="hidden" name="renderedAt" value={renderedAt} readOnly={true} />

            <div className="grid md:grid-cols-2 gap-4">
                <div>
                    <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-2">
                        Vorname *
                    </label>
                    <input
                        type="text"
                        id="firstName"
                        name="firstName"
                        required={true}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition-colors text-gray-900 placeholder-gray-500"
                        placeholder="Dein Vorname"
                    />
                </div>
                <div>
                    <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-2">
                        Nachname *
                    </label>
                    <input
                        type="text"
                        id="lastName"
                        name="lastName"
                        required={true}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition-colors text-gray-900 placeholder-gray-500"
                        placeholder="Dein Nachname"
                    />
                </div>
            </div>

            <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                    E-Mail-Adresse *
                </label>
                <input
                    type="email"
                    id="email"
                    name="email"
                    required={true}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition-colors text-gray-900 placeholder-gray-500"
                    placeholder="deine.email@beispiel.de"
                />
            </div>

            <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                    Nachricht *
                </label>
                <textarea
                    id="message"
                    name="message"
                    required={true}
                    rows={6}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition-colors resize-vertical text-gray-900 placeholder-gray-500 min-h-32"
                    placeholder="Deine Nachricht an uns..."
                />
            </div>

            <div>
                <button
                    type="submit"
                    className="w-full bg-amber-500 text-white font-semibold py-3 px-6 rounded-md hover:bg-amber-600 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2 transition-colors duration-200 flex items-center justify-center cursor-pointer"
                >
                    <span className="mr-2">📧</span>
                    Nachricht senden
                </button>
            </div>
            <p className="text-sm text-gray-500 text-center">* Pflichtfelder</p>
        </form>
    );
}
